import { memo, type KeyboardEvent } from 'react'
import { NodeResizer, type NodeProps } from '@xyflow/react'
import clsx from 'clsx'

import { useCanvasNodeContext } from '@/features/studio/canvas/CanvasNodeContext'
import type { StudioNodeData } from '@/features/studio/canvas/types'

type GroupNodeProps = NodeProps & {
  data: StudioNodeData
}

function GroupNodeInner({ id, data, selected }: GroupNodeProps) {
  const ctx = useCanvasNodeContext()
  const title = data.groupMeta?.title ?? data.label ?? '分组'
  const color = data.groupMeta?.color ?? '#6366f1'
  const onResizeEnd = ctx.onNodeGeometryChange

  function commitTitle(next: string) {
    const trimmed = next.trim()
    if (!trimmed || trimmed === title) return
    ctx.onPatch(id, {
      label: trimmed,
      groupMeta: { ...data.groupMeta, title: trimmed, color },
    })
  }

  function onTitleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') e.currentTarget.blur()
  }

  return (
    <>
      <NodeResizer
        nodeId={id}
        minWidth={120}
        minHeight={96}
        isVisible={selected}
        color={color}
        lineClassName="cn-group-resizer__line"
        handleClassName="cn-group-resizer__handle"
        onResizeEnd={() => onResizeEnd?.()}
      />
      <div
        className={clsx('cn-group-node nodrag', selected && 'cn-group-node--selected cn-shell--selected')}
        style={{ '--cn-group-color': color } as React.CSSProperties}
      >
        <div className="cn-group-node__label">
          <input
            className="cn-group-node__input nodrag nopan"
            defaultValue={title}
            onBlur={(e) => commitTitle(e.target.value)}
            onKeyDown={onTitleKeyDown}
          />
        </div>
      </div>
    </>
  )
}

export const GroupNode = memo(GroupNodeInner)
